import StaffSalesModule from "./staffSales";
import StaffSalesReducer from "./redux/salesReducer";
import StaffSalesSaga from "./redux/salesSaga";

export default {
  Component: StaffSalesModule,
  moduleName: "staffSales",
  saga: StaffSalesSaga(),
  reducer: StaffSalesReducer
};
